import { render, staticRenderFns } from "./class_teacher.vue?vue&type=template&id=23ebfe21&"
import script from "./class_teacher.vue?vue&type=script&lang=js&"
export * from "./class_teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports